module.exports = __webpack_public_path__ + "img/suggestion.554f7dba.svg";